import { render, staticRenderFns } from "./NewConsult.vue?vue&type=template&id=22fe5e94&scoped=true&"
import script from "./NewConsult.vue?vue&type=script&lang=js&"
export * from "./NewConsult.vue?vue&type=script&lang=js&"
import style0 from "./NewConsult.vue?vue&type=style&index=0&id=22fe5e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe5e94",
  null
  
)

export default component.exports